import {initialReportComparativeNomenclatureState, initialReportComparativeStoresState, initialReportDynamicsState, initialReportTotalState, IReportComparativeNomenclatureState, IReportComparativeStoresState, IReportDynamicsState, IReportTotalState} from "../../state/reports/reports-performance.state";
import {EReportsPerformanceActions, ReportsPerformanceActions} from "../../actions/reports/performance.actions";


export const reportPerformanceTotalReducers = (
  state = initialReportTotalState,
  action: ReportsPerformanceActions
):IReportTotalState =>{
  switch (action.type) {
    case EReportsPerformanceActions.GetTotal: {
      return {
        ...state
      };
    }
    case EReportsPerformanceActions.GetTotalSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsPerformanceActions.GetTotalFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false
      };
    }
    default:
      return state;
  }
};

export const reportPerformanceComparativeStoresReducers = (
  state = initialReportComparativeStoresState,
  action: ReportsPerformanceActions
):IReportComparativeStoresState =>{
  switch (action.type) {
    case EReportsPerformanceActions.GetComparativeStores: {
      return {
        ...state
      };
    }
    case EReportsPerformanceActions.GetComparativeStoresSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsPerformanceActions.GetComparativeStoresFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false
      };
    }
    default:
      return state;
  }
};
export const reportPerformanceComparativeNomenclatureReducers = (
  state = initialReportComparativeNomenclatureState,
  action: ReportsPerformanceActions
):IReportComparativeNomenclatureState =>{
  switch (action.type) {
    case EReportsPerformanceActions.GetComparativeNomenclature: {
      return {
        ...state
      };
    }
    case EReportsPerformanceActions.GetComparativeNomenclatureSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsPerformanceActions.GetComparativeNomenclatureFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false
      };
    }
    default:
      return state;
  }
};

export const reportPerformanceDynamicsReducers = (
  state = initialReportDynamicsState,
  action: ReportsPerformanceActions
):IReportDynamicsState =>{
  switch (action.type) {
    case EReportsPerformanceActions.GetDynamics: {
      return {
        ...state
      };
    }
    case EReportsPerformanceActions.GetDynamicsSuccess: {
      return {
        ...state,
        data: action.payload,
        isDataLoaded: true
      };
    }
    case EReportsPerformanceActions.GetDynamicsFailure: {
      return {
        ...state,
        data:[],
        isDataLoaded: false
      };
    }
    default:
      return state;
  }
};
